import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  text: {
    marginTop: '5vh',
    marginRight: '10%',
    marginLeft: '10%',
  },
  header: {
    marginTop: theme.spacing(4),
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  form: {
    width: '95%',
  },
  linkField: {
    marginBottom: theme.spacing(2),
  },
}));
